export type MenuGroupKey = "/review" | "/opr" | "/platform" | "/user" | "/goods" | "/system";

declare module "@tanstack/react-router" {
  interface StaticDataRouteOption {
    menuLabel?: string;
    showInMenu?: boolean;
    menuGroup?: MenuGroupKey;
    menuOrder?: number;
    /** 详情/编辑页高亮到该菜单 path */
    menuHighlightPath?: string;
    /** 仅超级管理员可见 */
    requireSuperAdmin?: boolean;
  }
}

export const goodsDetailSearchSchema = (search: Record<string, unknown>) => ({
  type: String(search.type ?? ""),
  id: String(search.id ?? ""),
});

export const selectionLogSearchSchema = (search: Record<string, unknown>) => ({
  productName: search.productName ? String(search.productName) : undefined,
  promotionStatus: search.promotionStatus ? String(search.promotionStatus) : undefined,
});

export const invitationSearchSchema = (search: Record<string, unknown>) => ({
  inviterName: search.inviterName ? String(search.inviterName) : undefined,
});
